// extracted by mini-css-extract-plugin
export default {"icon":"flRWn","iconFallback":"Wcq3u"};